
import Decimal from "decimal.js";

export type PlayStatus = "play" | "pause" | "stop";
export type FunctionStatus = "disable" | "enable" | "active";



export const radioOptions = [
  {
    label: "正常",
    value: "enable",
    color: "green",
  },
  {
    label: "失效",
    value: "disable",
    color: "red",
  },
];

export function parseNegative(data: number) {
  return data < 0 ? 0 : data;
}
export function parseMotTq(data: number) {
  if (data < 0) return 0;
  const value = new Decimal(data);
  return value.times(11.5).toDecimalPlaces(1).toNumber();
}
export function parseStatus(data: number): FunctionStatus {
  return data === 0 ? "enable" : "disable";
}
export function buildStatus(data: FunctionStatus) {
  return data === "enable" ? 0 : 1;
}

// 示例使用
// const rpm = 100; // 每分钟转数
// const diameter = 0.5; // 轮子直径（米）
// const kph = rpmToKph(rpm);

export const getDefaultSeriesData = () => {
  const res = {
    UIRx_SBW_HWAAng: [],
    UIRx_AxleStAng_FA: [],
    UIRx_AxleStAng_RA: [],
    UIRx_ACUYawRate: [],
    UIRx_ACULongdAcc: [],
  } as DomianControl.BFDSeriesData;
  return res;
};

export const optionseries1 = () => [
  {
    id: "UIRx_SBW_HWAAng",
    name: "方向盘转角",
    color: "#2196f3",
  },
];
export const optionseries2 = () => [
  {
    id: "UIRx_AxleStAng_FA",
    name: "前轴角度",
    color: "#ffeb3b",
  },
  {
    id: "UIRx_AxleStAng_RA",
    name: "后轴角度",
    color: "#03b152",
  },
];
export const optionseries3 = () => [
  {
    id: "UIRx_ACUYawRate",
    name: "横摆角速度",
    color: "#ffc107",
  },
];
export const optionseries4 = () => [
  {
    id: "UIRx_ACULongdAcc",
    name: "纵向减速度",
    color: "#ff0301",
  },
];

// export const decreasingSequence = generateNumbers(10, 0);
